import AccordionTextBlock from "@/components/AccordionTextBlock/AccordionTextBlock";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import TextBlock from "@/components/TextBlock/TextBlock";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxDisclosurePanel = ({ dashboard, flex }: FundDetailLayoutComponentProps) => {
	const { fxDisclosurePanel: props } = dashboard;
	if (!props) {
		return null;
	}

	const { disclaimer, ...rest } = props;

	return (
		<ContentBlock id="fxDisclosurePanel" data-testid="FxDisclosurePanel" flex={flex} tabIndex={-1}>
			{disclaimer !== undefined && <TextBlock content={disclaimer} />}
			{rest.content && <AccordionTextBlock {...rest} />}
		</ContentBlock>
	);
};
